import { getMasteryLabels } from "@helpers/content/distribution";

const defaultDistributionFilterItems = [
	{
		distKey: "none",
		label: {
			"en-US": "Not answered",
		},
		color: undefined,
	},
	{
		distKey: "low",
		label: {
			"en-US": getMasteryLabels().low,
		},
	},
	{
		distKey: "medium",
		label: {
			"en-US": getMasteryLabels().medium,
		},
	},
	{
		distKey: "high",
		label: {
			"en-US": getMasteryLabels().high,
		},
	},
];

export { defaultDistributionFilterItems };
